import { render, staticRenderFns } from "./mulitAssetsInfo.popup-chunk.vue?vue&type=template&id=342cf07f&scoped=true"
import script from "./mulitAssetsInfo.popup-chunk.vue?vue&type=script&lang=ts"
export * from "./mulitAssetsInfo.popup-chunk.vue?vue&type=script&lang=ts"
import style0 from "./mulitAssetsInfo.popup-chunk.vue?vue&type=style&index=0&id=342cf07f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342cf07f",
  null
  
)

export default component.exports